import clsx from 'clsx'
import { format } from 'date-fns/format'
import Icon from 'lib/components/Icon/Icon'
import { useMemo } from 'react'
import { ShipmentDetailsModalProps } from '../ShipmentDetailsModal'

export interface ShipmentDetailsModalHistoryProps {
  status?: ShipmentDetailsModalProps['status']
  updates: ShipmentDetailsModalProps['updates']
}

export default function ShipmentDetailsModalHistory({
  status,
  updates,
}: ShipmentDetailsModalHistoryProps) {
  const lastIndex = updates.length - 1
  const isDelivered = useMemo(() => status === 'delivered', [status])

  return (
    <div className="mt-6">
      <h2 className="type-body-1">Status tracker</h2>
      <div className="mt-6">
        {updates.map((update, index) => (
          <div
            key={index}
            className={clsx(
              'relative px-4 ml-6 border-b border-neutral-400',
              'lg:flex flex-nowrap gap-x-20',
              index ? 'py-4' : 'pb-4',
              index % 2 && 'bg-neutral-200',
            )}
          >
            <div className="type-body-5 lg:flex-[1.2]">
              <div
                className={clsx(
                  'flex flex-col items-center gap-y-2 absolute top-0 -bottom-1 -left-6 ',
                  index || isDelivered
                    ? 'text-theme-accessibility'
                    : 'text-theme-primary',
                  index && 'mt-3 lg:mt-[14px]',
                )}
              >
                <Icon
                  icon={
                    index || isDelivered
                      ? 'check-circle-filled'
                      : status === 'pending_shipment'
                        ? 'clock'
                        : status === 'delayed'
                          ? 'warning-triangle-filled'
                          : 'check-circle-outline'
                  }
                  className="w-6 h-6"
                />
                {/* Line */}
                {index !== lastIndex ? (
                  <div
                    className={clsx(
                      'flex-1 w-0',
                      isDelivered
                        ? 'border-current border-l'
                        : 'border-neutral-600 border-dashed border-l-2',
                    )}
                  ></div>
                ) : null}
              </div>
              {update.title}
            </div>
            <address className="mt-2 type-body-6 not-italic  lg:flex-1 lg:text-sm  lg:min-h-12">
              <div className="lg:text-lg">
                {update.date_time
                  ? [
                      format(update.date_time, 'hh:mm a'),
                      format(update.date_time, 'MM/dd/yyyy'),
                    ].join(', ')
                  : null}
              </div>
              <div className="mt-2">{update.location}</div>
              {update.phone && <div className="mt-2">{update.phone}</div>}
            </address>
          </div>
        ))}
      </div>
      {status === 'cancelled' && (
        <p className="mt-2 type-body-3 text-red-600">
          This shipment has been cancelled.
        </p>
      )}
    </div>
  )
}
